<template>
    <slot name="sidebar">

        <div v-if="isSidebarShow" class="popupMenu">
            <div class="inside">
                <div class="topNav popupTopNav">
                    <div class="inside">
                        <div class="left">
                            <img :src="require('@/static/img/etc/close_button_white.svg')" @click="hideSideMenu" />
                        </div>
                        <div class="middle">메뉴</div>
                        <div class="right">
                        </div>
                    </div>
                </div>

                <template v-for="menu in computedMenuList" :key="menu.menuNo">

                    <!-- 
                    <template v-if="menu.subMenu.length > 0">
                        <li class="nav-item" :class="{'active': menu.show}">
                            <a class="nav-link" @click="menuClick(menu.menuNo)">
                                <i class="fas fa-fw fa-tachometer-alt"></i>
                                <span>{{menu.menuNm}}</span>
                            </a>
                            <div class="collapse" :class="{show: menu.show}">
                                <div class="bg-white py-2 collapse-inner rounded">
                                    <div v-for="child in menu.subMenu" :key="child.menuNo">
                                        <a v-if="child.show" class="collapse-item" @click="gotoMenu(child.menuNo, child.url)">{{child.menuNm}}</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </template>
                    <template v-else>
                        <li class="nav-item" :class="{'active': menu.show}">
                            <a class="nav-link" @click="gotoMenu(menu.url)">
                                <i class="fas fa-fw fa-tachometer-alt"></i>
                                <span>{{menu.menuNm}}</span>
                            </a>
                        </li>
                    </template> -->

                    <!-- 카테고리 -->
                    <div class="list paddingBottom0 marginTop35">
                        <ul>
                            <div class="head textColorWhite">
                                <h1>{{menu.menuNm}}</h1>
                            </div>
                        </ul>
                    </div>
                    <!-- 카테고리 -->

                    <!-- 메뉴 화면 -->
                    <div class="maskedContainerOuter marginTop15">
                        <div class="inside insidePopup">
                            <ul>
                                <li v-for="child in menu.subMenu" :key="child.menuNo">
                                    <div v-if="child.show" class="subContentType1 subContentTypeNoBorder" @click="gotoMenu(child.menuNo, child.url)">
                                        <div class="top">
                                            <ul>
                                                <li>
                                                    <div class="title">
                                                        <h2>{{child.menuNm}}</h2>
                                                    </div>
                                                </li>
                                                <li class="data">
                                                    <ul>
                                                        <li>
                                                            <img :src="require('@/static/img/right_arrow_ico.svg')" />
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 메뉴 화면 -->
                </template>
            </div>
        </div>

    </slot>
</template>

<script>

import router from '@/router'
import * as types from '@/store/mutation-types'

import { ComUtil } from '@/utils/commonUtil.js'
import { WebUtil } from '@/utils/webUtil.js'
import { SessionUtil } from '@/utils/sessionUtil.js'

export default {
    data: function() {
        return {
            menuList: [
                {
                    menuNo: 'account', menuNm: '마이페이지', show: true, subMenu: [                    
                        {menuNo: 'PifoMng'  , menuNm: '내정보'     , url: '/pifo/PifoMng'  ,show: true},
                        {menuNo: 'PswdSet'  , menuNm: '암호변경'   , url: '/pifo/PswdCnfm' ,show: true},
                        {menuNo: 'Login'    , menuNm: '로그아웃'   , url: '/login'         ,show: true},
                    ]
                },
                {
                    menuNo: 'memb', menuNm: '구성원', show: true, subMenu: [
                        {menuNo: 'MembStat'  , menuNm: '직원현황'   , url: '/mng/MembStat'  ,show: true},
                    ]
                },
                {
                    menuNo: 'blbd', menuNm: '게시판', show: true, subMenu: [
                        {menuNo: 'BullStat'  , menuNm: '공지사항'   , url: '/api/BullStat'  ,show: true},
                        {menuNo: 'SgstStat'  , menuNm: '건의사항'   , url: '/api/SgstStat'  ,show: true},
                    ]
                },
                {
                    menuNo: 'cmon', menuNm: '일반업무', show: true, subMenu: [
                        {menuNo: 'VacaStat'   , menuNm: '휴가관리'    , url: '/mng/vacaStat'    , show: true},
                        {menuNo: 'VacaAprvMng', menuNm: '휴가승인관리' , url: '/mng/vacaAprvMng' , show: true},
                        {menuNo: 'CostStat'   , menuNm: '경비관리'    , url: '/mng/costStat'    , show: true},
                        {menuNo: 'SchdStat'   , menuNm: '일정관리'    , url: '/mng/SchdStat'    , show: true},
                        {menuNo: 'AttdLvMng'  , menuNm: '출퇴근관리'  , url: '/mng/AttdLvMng'   , show: true},
                    ]
                },
            ]
        }
    },
    methods: {
        init: function() {
            let $this = this;
        },
        menuClick: function(div) {
            let $this = this;
            _.forEach($this.menuList, function(menu) {
                if ( menu.menuNo !== div ) {
                    menu.show = false;
                } else {
                    menu.show = true;
                }
            });
        },
        gotoMenu: function(menuNo, url) {
            let $this = this;
            $this.$store.commit(types.SIDE_BAR, false);
            $this.resetMenu();

            const userRole = SessionUtil.getUserRoleList();

            if (menuNo === 'SchdStat') {
                if (!userRole.some(role => role.roleCd === "SCHD_USER")) {
                    $this.alert("일정사용자 권한을 가진 사용자만 이용할 수 있습니다.");
                    return false;
                }
            }

            if ( menuNo === 'Login' ) {
                let platform = "MOBILE";
                ComUtil.logout(platform);
                router.replace({name: 'Login'});
                setTimeout(function() {
                    WebUtil.alert('로그아웃 되었습니다.');
                }, 200);
            } else if( menuNo === 'PifoMng') {
                const sendParam = {'userId': SessionUtil.getUserId(), 'from':'stat'};
                $this.setRouter(menuNo, sendParam);
            } else if( menuNo === 'PswdSet') {
                router.push({
                    path: url,
                    name: 'PswdCnfm',
                    query: { redirect: menuNo },
                });
            } else {
                router.push({
                    path: url,
                    name: menuNo
                });
            }
        },
        resetMenu: function() {
            let $this = this;
            _.forEach($this.menuList, function(menu) {
                menu.show = false;
            });
        },
        hideSideMenu: function() {
            let $this = this;
            $this.$store.commit(types.SIDE_BAR, false);
        }
    },
    computed: {
        isSidebarShow: function() {
            return this.$store.getters.sidebar;
        },
        isVacaAprv() {
            return this.$store.getters.isVacaAprv;
        },
        computedMenuList() {
            return this.menuList.map(menu => {
                if (menu.menuNo !== 'cmon') return menu;
                return {
                    ...menu,
                    subMenu: menu.subMenu.map(child => ({
                        ...child,
                        show: child.menuNo === 'VacaAprvMng' ? this.isVacaAprv : child.show
                    }))
                };
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
.popupMenu {
    z-index: 1000;
    overflow: auto;
}

.maskedContainerOuter > .inside {
    max-height: 550px;
}
</style>